import { useMutation } from '@tanstack/react-query'
import { verify2FACode } from 'services/ApiKeysService'

export const useTwoFactorCodeMutation = () => {
  return useMutation({ mutationFn: verify2FACode })
}
